import { useSelector } from "react-redux";

import clsx from "clsx";

import { getMessagePreviewById } from "utils/message";
import { handleScrollIntoView } from "utils/view";
import ProgressBar from "components/ProgressBar";
import { truncate } from "utils/text";
import styles from "./styles.module.scss";

const getLocale = ({ settingsData }) => settingsData.locale;
const getSelectedConversation = ({ chatsData }) =>
  chatsData.selectedConversation;

const FileMessage = ({
  id,
  erorr,
  delivered,
  url,
  // time,
  name,
  size,
  // type,
  replyId,
  // status,
  progress,
}) => {
  const locale = useSelector(getLocale);
  const selectedConversation = useSelector(getSelectedConversation);

  const fileName = name || "file";

  const getFileTypeFromName = (name = "file") => {
    const nameArray = String(name).split(".");
    const lastWord = nameArray[nameArray.length - 1];

    return lastWord.toUpperCase();
  };

  const handleShowRepliedMessage = () => {
    handleScrollIntoView(replyId);
  };

  const renderFileIcon = () => {
    if (![null, undefined].includes(progress) && !delivered) {
      return (
        <ProgressBar
          progress={progress}
          trackColor="#FFF"
          trackWidth={4}
          size={30}
          indicatorWidth={4}
        />
      );
    }

    // TODO: implementation
    if (erorr) {
      return (
        <div className="conv__body__body__inner__msgright__inner__bubble__file__download_icon resend flex-noflex"></div>
      );
    }

    return (
      <a href={url}>
        <div className="conv__body__body__inner__msgright__inner__bubble__file__download_icon flex-noflex"></div>
      </a>
    );
  };

  return (
    <div
      data-id={id}
      className="conv__body__body__inner__msgright__inner__bubble flex flex-ai-e flex-jc-sb"
    >
      <div className="conv__body__body__inner__msgright__inner__bubble__file flex-ai-s error ">
        {replyId && (
          <div
            dir="auto"
            className="conv__body__body__inner__msgright__inner__bubble__replied_msg"
            onClick={handleShowRepliedMessage}
          >
            <span>
              {getMessagePreviewById(replyId, selectedConversation, locale)}
            </span>
          </div>
        )}
        <div className={clsx(["flex flex-ai-c", styles.file_inner])}>
          <div className="conv__body__body__inner__msgright__inner__bubble__file__type_icon  flex flex-ai-c flex-jc-c flex-noflex pdf">
            {getFileTypeFromName(fileName)}
          </div>
          <div className="conv__body__body__inner__msgright__inner__bubble__file__text">
            <div className="conv__body__body__inner__msgright__inner__bubble__file__text__title">
              {truncate(fileName, 25)}
            </div>
            <div className="conv__body__body__inner__msgright__inner__bubble__file__text__size">
              {size}
            </div>
          </div>

          <div className={styles.file_icon_wrapper}>{renderFileIcon()}</div>

          {/* {erorr ? (
            <div className="conv__body__body__inner__msgright__inner__bubble__file__download_icon resend flex-noflex"></div>
          ) : (
            <a href={url}>
              <div className="conv__body__body__inner__msgright__inner__bubble__file__download_icon flex-noflex"></div>
            </a>
          )} */}
          {/* <div className="conv__body__body__inner__msgright__inner__bubble__file__info flex flex-ai-c flex-jc-sb w-100"> */}
          {/* {delivered && (
              <div className="conv__body__body__inner__msgright__inner__bubble__file__info__delivery delivered"></div>
            )} */}
          {/* <div>
              {status === "sent" && (
                <OneCheckIconComponent className="OneCheckIcon" />
              )}
              {status === "seen" && (
                <TwoCheckIconComponent className="TwoCheckIcon" />
              )}
            </div> */}
          {/* 
            {erorr && (
              <div className="conv__body__body__inner__msgright__inner__bubble__file__info__delivery error"></div>
            )}
            <div className="conv__body__body__inner__msgright__inner__bubble__file__info__time">
              {time}
            </div> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default FileMessage;
